<div class="details">
    <div class="details-value" *ngIf="value">
        <div class="details-value-title" id="entry-value">
            {{value}}
        </div>
    </div>
    <div class="details-label">
        <div class="details-label-title" id="entry-label">
            {{title}}
        </div>
    </div>
</div>
<div class="attributes" id="entry-attributes" *ngIf="attributes">
    <ng-content select="fui-attributed-list-entry-attributes"></ng-content>
</div>
<div class="action" id="action" *ngIf="link">
    <div class="action-media">
        <fui-icon [height]="16" [icon]="'chevron-right'" [width]="8"></fui-icon>
    </div>
</div>
